import React, { useEffect, useState } from 'react';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import { fetchCroppedImage } from '@/utils/constants';
import { ColorPicker } from 'primereact/colorpicker';
import { toast } from 'react-toastify';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import { RootState } from '@/core/redux/store';

const HomeEditBannerModalThree = ({ theme_5, getThemeData }: any) => {
  const [editData, setEditData] = useState<any>();
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);
  const [activeTab, setActiveTab] = useState(0);

  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [backgroundImages, setBackgroundImages] = useState<string[]>([]);

  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData?.theme_5?.home.section_7.card_section,
    ];
    if (index != undefined) {
      updatedCollection = [...editData?.theme_5?.home.section_7.card_section];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        ...prevJsonData?.theme_5,
        home: {
          ...prevJsonData?.theme_5.home,
          section_7: {
            ...prevJsonData?.theme_5?.home.section_7,
            [name]: value,
            card_section: updatedCollection,
          },
        },
      },
    }));
  };

  const addCollectionOne = () => {
    let updatedCollection: any = [
      ...editData.theme_5.home.section_7.card_section,
    ];

    let newCard = {
      text: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        ...prevJsonData.theme_5,
        home: {
          ...prevJsonData.theme_5.home,
          section_7: {
            ...prevJsonData.theme_5.home.section_7,
            card_section: updatedCollection,
          },
        },
      },
    }));
  };

  const removeCollectionOne = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_5.home.section_7.card_section,
    ];
    updatedCollection.splice(index, 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        ...prevJsonData.theme_5,
        home: {
          ...prevJsonData.theme_5.home,
          section_7: {
            ...prevJsonData.theme_5.home.section_7,
            card_section: updatedCollection,
          },
        },
      },
    }));
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150")
    // setCropImageWidth("150")
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleBannerImageChange(imageLink);
    }
  };

  const handleBannerImageChange = (image: string) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_5: {
        ...prevJsonData.theme_5,
        home: {
          ...prevJsonData.theme_5.home,
          section_7: {
            ...prevJsonData.theme_5.home.section_7,
            banner: image,
          },
        },
      },
    }));
  };

  // Auto-generate prompt based on section 7 context for Background Banner
  const generateAutoPromptBanner = (): string => {
    const title = editData?.theme_5?.home?.section_7?.title || '';
    const paragraph1 = editData?.theme_5?.home?.section_7?.paragraph1 || '';
    const paragraph2 = editData?.theme_5?.home?.section_7?.paragraph2 || '';
    const paragraph3 = editData?.theme_5?.home?.section_7?.paragraph3 || '';
    const paragraph4 = editData?.theme_5?.home?.section_7?.paragraph4 || '';
    
    let contextPrompt = 'modern professional banner image for website section';
    
    if (title || paragraph1 || paragraph2 || paragraph3 || paragraph4) {
      const contextParts: string[] = [];
      const allParagraphs = [paragraph1, paragraph2, paragraph3, paragraph4].filter(p => p).join(' ');
      if (allParagraphs) {
        const keywords = allParagraphs.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    contextPrompt += ', clean modern aesthetic, professional photography, suitable for section banner, square format, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI background banner image save
  const handleAIImageSave = (imageUrl: string) => {
    handleBannerImageChange(imageUrl);
    setBackgroundImages(prevImages => [...prevImages, imageUrl]);
    
    const templateKey = template ? `template${template}` : 'template5';
    const currentTemplate = templateImages[templateKey] || {};
    const currentImages = currentTemplate.image || [];
    const updatedTemplateImages = {
      ...templateImages,
      [templateKey]: {
        ...currentTemplate,
        image: [...currentImages, { url: imageUrl }],
      },
    };
    dispatch(setTemplateImages(updatedTemplateImages));
  };

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    setEditData(theme_5);
  }, [theme_5]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store with filtering
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template5';
      const currentTemplate = templateImages[templateKey];
      const imageImgs = currentTemplate?.image || [];

      const loadImageDimensions = async (url: string): Promise<{ url: string; width: number; height: number } | null> => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve({ url, width: img.width, height: img.height });
          img.onerror = () => resolve(null);
          img.src = url;
        });
      };

      if (Array.isArray(imageImgs) && imageImgs.length > 0) {
        const filterBackgroundImages = async () => {
          const imagePromises = imageImgs.map((img: any) => loadImageDimensions(img.url));
          const loadedImages = await Promise.all(imagePromises);
          const squareImages = loadedImages
            .filter((img) => {
              if (img === null) return false;
              const aspectRatio = img.width / img.height;
              return aspectRatio >= 0.9 && aspectRatio <= 1.1;
            })
            .map((img) => img!.url);
          setBackgroundImages(squareImages);
        };
        filterBackgroundImages();
      } else {
        setBackgroundImages([]);
      }
    } else {
      setBackgroundImages([]);
    }
  }, [templateImages, template]);

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section7 Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="title"
                      value={editData?.theme_5?.home?.section_7?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                    <div className="mb-3">
                      <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                        <label className="form-label mb-0 mr-2">paragraph 1</label>
                        <AIContentWriter
                          onContentGenerated={(content) => {
                            handleChange({ target: { name: 'paragraph1', value: content } });
                          }}
                          contentType="website_description"
                          placeholder="Describe the paragraph content you want"
                          context="This is for section 7 paragraph 1 with 3 line max"
                        />
                      </div>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph1"
                      value={editData?.theme_5?.home?.section_7?.paragraph1}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                    <div className="mb-3">
                      <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                        <label className="form-label mb-0 mr-2">paragraph 2</label>
                        <AIContentWriter
                          onContentGenerated={(content) => {
                            handleChange({ target: { name: 'paragraph2', value: content } });
                          }}
                          contentType="website_description"
                          placeholder="Describe the paragraph content you want"
                          context="This is for section 7 paragraph 2 with 3 line max"
                        />
                      </div>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph2"
                      value={editData?.theme_5?.home?.section_7?.paragraph2}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                    <div className="mb-3">
                      <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                        <label className="form-label mb-0 mr-2">paragraph 3</label>
                        <AIContentWriter
                          onContentGenerated={(content) => {
                            handleChange({ target: { name: 'paragraph3', value: content } });
                          }}
                          contentType="website_description"
                          placeholder="Describe the paragraph content you want"
                          context="This is for section 7 paragraph 3 with 3 line max"
                        />
                      </div>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph3"
                      value={editData?.theme_5?.home?.section_7?.paragraph3}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                    <div className="mb-3">
                      <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                        <label className="form-label mb-0 mr-2">paragraph 4</label>
                        <AIContentWriter
                          onContentGenerated={(content) => {
                            handleChange({ target: { name: 'paragraph4', value: content } });
                          }}
                          contentType="website_description"
                          placeholder="Describe the paragraph content you want"
                          context="This is for section 7 paragraph 4 with 3 line max"
                        />
                      </div>
                    <input
                      type="text"
                      className="form-control"
                      name="paragraph4"
                      value={editData?.theme_5?.home?.section_7?.paragraph4}
                      onChange={handleChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">header 1 Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_5?.home?.section_7?.h2color}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_5?.home?.section_7?.h2color}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md">
                  <div className="mb-3">
                    <label className="form-label">paragraph Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_5?.home?.section_7?.paracolor}
                        onChange={handleChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleChange}
                        value={editData?.theme_5?.home?.section_7?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* Upload moved below AI generator */}
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="img-bg active">
                          {editData?.theme_5?.home?.section_7?.banner && (
                            <img
                              src={editData?.theme_5?.home?.section_7?.banner}
                              alt="Hero Image"
                            />
                          )}
                        </div>
                        <div className="img-options">
                          <div className="row">
                            <div className="col-md-12">
                              {backgroundImages.length > 0 ? (
                                <Swiper
                                  spaceBetween={15}
                                  navigation={true}
                                  modules={[Navigation]}
                                  breakpoints={{
                                    640: { slidesPerView: 1 },
                                    768: { slidesPerView: 4 },
                                    1024: { slidesPerView: 6 },
                                  }}
                                  className="homejson-slider"
                                >
                                  {backgroundImages.map((imageUrl: string, idx: number) => (
                                    <SwiperSlide key={idx}>
                                      <div className="img-option" onClick={() => handleBannerImageChange(imageUrl)}>
                                        <img src={imageUrl} alt="Hero Image" className="img-fluid" />
                                      </div>
                                    </SwiperSlide>
                                  ))}
                                </Swiper>
                              ) : (
                                <div className="empty-slider-state text-center py-4">
                                  <div className="empty-state-content">
                                    <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                    <h6 className="text-muted mb-2">No Background Images Available</h6>
                                    <p className="text-muted small mb-3">Generate AI images or upload your own to see them here</p>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* AI Image Generator */}
            <AIImageGenerator
              generateAutoPrompt={generateAutoPromptBanner}
              onSave={handleAIImageSave}
              imageType="image"
              defaultWidth="1024"
              defaultHeight="1024"
              title="AI Image"
              autoGenerate={true}
              template={template}
            />
            <div className="row">
              <div className="col">
                <div className="mb-3">
                  <label className="form-label">Upload Image</label>
                  <input type="file" accept="image/png, image/jpeg" className="form-control" name="image" onChange={updateImageSectionOne} />
                </div>
              </div>
            </div>
            <div className="edit-section">
              <h5 className="modal-title">Card Section One</h5>
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_5?.home?.section_7?.card_section.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Card {index + 1}
                          </a>
                          <a
                            className="tab-close"
                            onClick={() => {
                              removeCollectionOne(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_5?.home?.section_7?.card_section.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="mb-3">
                        <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                          <label className="form-label mb-0 mr-2">Title</label>
                          <AIContentWriter
                            onContentGenerated={(content) => {
                              handleChange({ target: { name: 'text', value: content } }, index);
                            }}
                            contentType="website_description"
                            placeholder="Describe the title you want"
                            context="This is for a section 7 card title with 1 line or 10 words max"
                          />
                        </div>
                        <input
                          type="text"
                          className="form-control"
                          name="text"
                          value={card.text}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
              <div className="add-section">
                <div className="row">
                  <div
                    onClick={() => {
                      addCollectionOne();
                    }}
                    className="col text-center"
                  >
                    Add Card<i className="fas fa-plus-square ms-2"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={saveJsonData}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default HomeEditBannerModalThree;
